<template>
  <v-container fluid>
    <div class="d-flex justify-space-between align-center py-2">
      <span class="font-weight-medium py-2 flex-shrink-0">
        การจัดการ กลุ่มพนักงาน
      </span>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="handleAddTaEmployeesGroupForm">
        <v-icon small left>mdi-plus</v-icon>เพิ่มกลุ่มพนักงาน
      </v-btn>
    </div>
    <v-card outlined>
      <v-row align="center" class="ma-0">
        <v-col md="3" lg="3" xl="2">
          <v-text-field
            v-model="search"
            label="ค้นหา"
            prepend-inner-icon="mdi-magnify"
            clearable
            dense
            outlined
            hide-details
          ></v-text-field>
        </v-col>
      </v-row>
    </v-card>
    <v-data-table
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      :loading="loading"
      loading-text="Loading... Please wait"
      :search="search"
      :headers="headers"
      :items="taEmployeesGroup"
      :items-per-page="10"
      class="elevation-1 mt-3"
      :footer-props="{
        itemsPerPageOptions: [10, 25, 50, 100],
        itemsPerPageText: 'Rows per page:',
      }"
      :item-class="classRowSelected"
      @click:row="handleRowSelected"
    >
    </v-data-table>
    <TaEmployeeGroupForm
      :formShow="taEmployeeGroupFormShow"
      :formAction="taEmployeeGroupFormAction"
      :taEmployeeGroup="taEmployeeGroup"
      :taEmployeeGroupInit="taEmployeeGroupInit"
      @isTaEmployeeGroupDataChange="handleTaEmployeeGroupFormDataChange"
      @formActionCompleted="handleTaEmployeeGroupFormActionCompleted"
      @onReset="handleTaEmployeeGroupFormReset"
      @onClickAddTaEmployee="taEmployeeGroupAddShow = true"
      @addTaEmployeeGroupSuccess="handleAddTaEmployeeGroupSuccess"
    />
    <TaEmployeeGroupAdd
      :formShow="taEmployeeGroupAddShow"
      :taEmployeeGroup="taEmployeeGroup"
      :taEmployeeGroupInit="taEmployeeGroupInit"
      @isTaEmployeeGroupAddDataChange="handleTaEmployeeGroupAddDataChange"
      @onClickBlack="taEmployeeGroupAddShow = false"
      @addTaEmployeeGroupMemberSuccess="handleAddTaEmployeeGroupMemberSuccess"
    />
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
    <v-overlay
      :value="
        (taEmployeeGroupFormShow && taEmployeeGroupFormAction === 'add') ||
        taEmployeeGroupAddShow
      "
      z-index="0"
    ></v-overlay>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'

// @ is an alias to /src
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import TaEmployeeGroupAdd from '@/views/ta-employees-group/TaEmployeeGroupAdd.vue'
import TaEmployeeGroupForm from '@/views/ta-employees-group/TaEmployeeGroupForm.vue'

export default {
  components: {
    TaEmployeeGroupForm,
    TaEmployeeGroupAdd,
    ConfirmDialog,
  },
  data() {
    return {
      sortBy: ['title_th'],
      sortDesc: [false],
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
      loading: false,
      search: '',
      taEmployeeGroupFormShow: false,
      taEmployeeGroupAddShow: false,
      taEmployeeGroupFormAction: '',
      taEmployeeGroup: {},
      taEmployeeGroupInit: {},
      isTaEmployeeGroupDataChange: false,
      isTaEmployeeGroupAddDataChange: false,
      timeout: null,
    }
  },
  computed: {
    headers() {
      return [
        { text: 'คำอธิบาย (ไทย)', align: 'start', value: 'title_th' },
        {
          text: 'จำนวนพนักงาน',
          align: 'start',
          value: 'employee_group_member.total',
        },
      ]
    },
    taEmployeesGroup() {
      return this.$store.state.taEmployeesGroup.taEmployeesGroup
    },
  },
  created() {
    this.$store.commit('SET_BREADCRUMBS', [
      { text: 'หน้าหลัก', disabled: false, to: '/' },
      {
        text: 'การจัดการ กลุ่มพนักงาน',
        disabled: true,
      },
    ])

    this.loading = true
    const { company_uuid } = this.$store.state.authentication.company

    Promise.all([
      this.fetchTaEmployeesGroup({ company_uuid }),
      this.fetchOrganizations({
        company_uuid,
        params: {
          dpc: 'employee-to-list-organization',
          field: 'organization_uuid,organization_code,title_th',
        },
      }),
    ])
      .then(() => {
        this.loading = false
      })
      .catch((error) => {
        this.loading = false

        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      })
  },
  methods: {
    ...mapActions({
      fetchOrganizations: 'organization/fetchOrganizations',
      fetchTaEmployeesGroup: 'taEmployeesGroup/fetchTaEmployeesGroup',
    }),
    handleAddTaEmployeeGroupMemberSuccess(taEmployeeGroup) {
      this.taEmployeeGroupAddShow = false
      this.taEmployeeGroup = { ...taEmployeeGroup }
      this.taEmployeeGroupInit = { ...taEmployeeGroup }
    },
    handleAddTaEmployeeGroupSuccess(taEmployeeGroup) {
      this.taEmployeeGroup = { ...taEmployeeGroup }
      this.taEmployeeGroupInit = { ...taEmployeeGroup }
    },
    classRowSelected(row) {
      if (this.taEmployeeGroup.employee_group_uuid === row.employee_group_uuid)
        return 'row-selected'
    },
    setDataRowSelected(row) {
      if (
        this.taEmployeeGroup.employee_group_uuid === row.employee_group_uuid
      ) {
        this.taEmployeeGroupFormShow = false
        this.taEmployeeGroupFormAction = ''
        this.taEmployeeGroup = {}
        this.taEmployeeGroupInit = {}
      } else {
        this.taEmployeeGroupFormShow = true
        this.taEmployeeGroupFormAction = 'edit'
        this.taEmployeeGroup = { ...row }
        this.taEmployeeGroupInit = { ...row }
      }
    },
    handleRowSelected(row) {
      if (this.isTaEmployeeGroupDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
          item: {
            type: 'row',
            data: row,
          },
        }
        this.confirmDialogDataChange = true
      } else {
        this.setDataRowSelected(row)
      }
    },
    handleAddTaEmployeesGroupForm() {
      this.taEmployeeGroupFormShow = true
      this.taEmployeeGroupFormAction = 'add'
      this.taEmployeeGroup = {}
      this.taEmployeeGroupInit = {}
    },
    handleTaEmployeeGroupFormDataChange(value) {
      this.isTaEmployeeGroupDataChange = value
    },
    handleTaEmployeeGroupAddDataChange(value) {
      this.isTaEmployeeGroupAddDataChange = value
    },
    handleTaEmployeeGroupFormReset(formAction) {
      if (formAction === 'edit') {
        this.taEmployeeGroup = { ...this.taEmployeeGroupInit }
      }
    },
    handleTaEmployeeGroupFormActionCompleted(formAction) {
      this.taEmployeeGroup = {}
      this.taEmployeeGroupInit = {}
      this.taEmployeeGroupFormShow = false
      this.taEmployeeGroupFormAction = ''
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange(item) {
      if (item.type === 'row') {
        this.confirmDialogDataChange = false
        this.setDataRowSelected(item.data)
      } else {
        this.confirmDialogDataChange = false
        this.nextRoute(item.data)
      }
    },
    nextRoute(next) {
      this.taEmployeeGroupFormShow = false
      this.taEmployeeGroupAddShow = false
      this.timeout = setTimeout(() => {
        next()
      }, 200)
    },
  },
  beforeRouteLeave(to, from, next) {
    if (
      this.isTaEmployeeGroupDataChange ||
      this.isTaEmployeeGroupAddDataChange
    ) {
      this.confirmDialogDataChangeData = {
        title: 'ต้องการออกจากหน้านี้ใช่ไหม',
        text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการออกโดยที่ยังไม่บันทึกข้อมูล',
        value: '',
        item: {
          type: 'next',
          data: next,
        },
      }
      this.confirmDialogDataChange = true
    } else {
      this.nextRoute(next)
    }
  },
  beforeDestroy() {
    clearTimeout(this.timeout)
  },
}
</script>
